import { render, staticRenderFns } from "./FreetextEdit.vue?vue&type=template&id=4a8e38c5&"
import script from "./FreetextEdit.vue?vue&type=script&lang=js&"
export * from "./FreetextEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports